/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 09 2024
 **/

import { css } from "@emotion/react";

export const ShrinkButtonStyle = css`
	display: flex;
	gap: 0.3rem;
	justify-content: center;
	align-items: center;
`;

export const OpenButtonStyle = css`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border: solid 1px #3e3e3e;
	border-radius: 20px;
	padding: 20px;
	display: flex;
	align-items: center;
	gap: 1rem;
	color: black;
	visibility: hidden;
	pointer-events: auto;
	cursor: pointer;
	&.close {
		visibility: visible;
	}
`;

export const MaximizeButtonStyle = css`
	position: absolute;
	top: 10px;
	right: 10px;
	display: flex;
	justify-content: center;
	visibility: hidden;
	cursor: pointer;
	pointer-events: auto;
	&.minimize {
		visibility: visible;
	}
`;
